module.exports = __webpack_public_path__ + "img/itemImgActive.19921fc9.png";